/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class MessageReactionsAPI extends ApiClient {
  constructor() {
    super('loco/conversations', { accountScoped: true });
  }

  // An empty emoji removes the agent's reaction
  react(conversationId, messageId, emoji) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/reaction`,
      { emoji }
    );
  }
}

export default new MessageReactionsAPI();
